export default "__VITE_ASSET__BVZXxpGL__"